// Téléversement des images vers l'API Hermes, qui les stocke sur le
// disque du serveur (dossier api/uploads, servi publiquement sur
// /uploads). Remplace Firebase Storage : le bucket « blog-liste » a
// dépassé le quota du plan gratuit Spark (erreur storage/quota-exceeded).
//
// Deux usages :
//  - les dropzones des modals envoient directement le fichier vers
//    uploadUrl (url + headers + params de vue2-dropzone) ;
//  - uploadImage() envoie un Data URI (aperçu déjà lu par la page),
//    pour les logos des réglages de boutique.
import config from '../../config.json';

// URL de base de l'API : vide = même origine. En dev, le serveur Vue
// transmet /api et /uploads vers localhost:7001 (vue.config.js) ; en
// production, Nginx fait la même transmission (admin/deploy/nginx).
export const apiUrl = String(config.apiUrl || '').replace(/\/+$/, '');

// Point d'entrée de téléversement et clé API à mettre dans les options
// du dropzone : { url: uploadUrl, headers: uploadHeaders(), params: {...} }.
export const uploadUrl = apiUrl + '/api/uploads';

export function uploadHeaders() {
    return { 'x-api-key': config.apiKey || '' };
}

// Conversion Data URI -> envoi multipart. Renvoie une promesse résolue
// avec l'URL publique de l'image stockée (/uploads/...), ou rejetée avec
// le message d'erreur de l'API.
export function uploadImage(dataURI, folder, filename) {
    if (!dataURI) return Promise.resolve(null);
    // Le Data URI donne le vrai type MIME du contenu (les fonctions
    // dataURItoBlob des composants étiquettaient tout en « webp », y
    // compris des JPEG) : on s'en sert pour l'extension du fichier.
    const mime = (String(dataURI).match(/^data:([^;,]+)/) || [])[1] || 'image/webp';
    const extensions = {
        'image/webp': '.webp',
        'image/jpeg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/svg+xml': '.svg',
        'image/bmp': '.bmp',
        'image/avif': '.avif'
    };
    // Comme pour Firebase Storage : # [ ] * ? sont interdits dans un nom.
    const safeName = String(filename || 'image').replace(/[#\[\]*?]/g, '-');
    const byteString = atob(String(dataURI).split(',')[1]);
    const buffer = new ArrayBuffer(byteString.length);
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < byteString.length; i++) {
        bytes[i] = byteString.charCodeAt(i);
    }
    const form = new FormData();
    form.append('folder', folder);
    form.append('file', new Blob([buffer], { type: mime }),
        safeName + (extensions[mime] || '.bin'));
    return fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form })
        .then((res) => res.json().catch(() => ({})).then((data) => {
            if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status);
            return data.url;
        }));
}

// Affiche l'échec d'un téléversement (dropzone : événement vdropzone-error)
// au lieu de l'avaler silencieusement.
export function reportUploadError(vm, message) {
    let text = message;
    if (text && typeof text === 'object' && text.error) text = text.error;
    if (typeof text === 'string' && text.charAt(0) === '{') {
        try { text = JSON.parse(text).error || text; } catch (e) { /* texte brut */ }
    }
    const full = 'Image upload failed: ' + text;
    console.error(full);
    if (vm && vm.$toasted) vm.$toasted.error(full, { duration: 6000 });
}
